import React, { useContext, useState } from 'react'
import { ButtonsDiv, CloseDiv, CloseImg, Container, InviteButtonDiv, InviteButtonImage, InviteButtonText, HeaderDiv, HeaderText, InputDiv, InputAdminName, LabelCreate, TipParagraph, InputWrongParagraph } from './style'
import cross from '../../assets/addStockModal/cross.svg'
import paperPlane from '../../assets/assesses/paper-plane.svg'
import ModalContext from '../../contexts/ModalContext'
import axios from 'axios'
import UserContext from '../../contexts/UserContext'

const InviteNewAdmin:React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const [email, setEmail] = useState('')
  const [right, setRight] = useState(true)
  const { token } = useContext(UserContext)
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  const inviteAdmin = async (email:string): Promise<void> => {
    const matches = email.match(regex)
    if(!matches){
      setEmail('')
      setRight(false)
    }else{
      setRight(true)
      try{
        await axios.post(`${process.env.REACT_APP_BASE_URL}/new-admin/email`, {email:email},{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setModalActive(false)
      }catch(error){
        console.error('Erro ao convidar admin', error)
      }
    }
  }
  
  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Convidar novo administrador</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
            <CloseImg src={cross} alt='Close tab'/>
        </CloseDiv>
      </HeaderDiv>
      <TipParagraph>
        Insira o email do usuário a ser convidado e enviaremos instruções para o cadastro de administrador.
      </TipParagraph>
      <InputDiv>
        <LabelCreate>Email</LabelCreate>
        <InputAdminName
          placeholder='Digite aqui'
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </InputDiv>
      {right ? (
        null
      ): (
        <InputWrongParagraph>
          Precisa ser um email!
        </InputWrongParagraph>
      )}
      <ButtonsDiv onClick={() => inviteAdmin(email)}>
        <InviteButtonDiv>
          <InviteButtonImage src={paperPlane} alt='Paper-plane icon'/>
          <InviteButtonText>Enviar convite</InviteButtonText>
        </InviteButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default InviteNewAdmin